/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;

var _table = require("./table");

exports.Table = _table.Table;
exports.Caption = _table.Caption;
exports.Tr = _table.Tr;
exports.Thead = _table.Thead;
exports.Tbody = _table.Tbody;
exports.Tfoot = _table.Tfoot;
exports.Td = _table.Td;
exports.Th = _table.Th;
exports.TrHeaderForDrawers = _table.TrHeaderForDrawers;
exports.TrWithDrawer = _table.TrWithDrawer;
exports.TrWithoutDrawer = _table.TrWithoutDrawer;